import { objectSchema } from "vue-utils"
import { extend, GenericEntity, Named } from "./GenericEntity"

export interface Company extends GenericEntity, Named {
	mainContact: string

	telephoneNumber: string
	email: string

	address: string
	postcode: string
}

export const Company = objectSchema<Company>({
	...extend(GenericEntity, Named),
	mainContact: String,

	telephoneNumber: String,
	email: String,

	address: String,
	postcode: String,
})
